import './App.css';
import { useEffect, useState } from 'react';

import PageMarketingV2Menu from './PageMarketingV2Menu';
import PageMarketingV2Monetize from './PageMarketingV2Monetize';
import PageMarketingV2PresentLarge from './PageMarketingV2PresentLarge';
import PageMarketingV2PresentTechnology from './PageMarketingV2PresentTechnology';
import PageMarketingV2PresentTablets from './PageMarketingV2PresentTablets';
import PageMarketingV2PresentVertical from './PageMarketingV2PresentVertical';
import PageMarketingV2PresentFrame from './PageMarketingV2PresentFrame';

import { log } from './Logging';
import PageMarketingV2GDPR from './PageMarketingV2GDPR';

function PageMarketingV2() {
    const [creativeURL, setCreativeURL] = useState(
        'https://adtangs.fra1.digitaloceanspaces.com/7fdb86d8-1ff2-43df-8bbe-4825388dc9d0.mp4'
    );

    useEffect(
        () => {
            log('page-view-v2');
        },
        [],
    )

    return (
        <div style={{ width: '100%' }}>
            <PageMarketingV2Menu />
            <div style={{ marginTop: '4em' }}>
                <PageMarketingV2GDPR />
            </div>
            <PageMarketingV2PresentLarge
                creativeURL={creativeURL}
            />
            <PageMarketingV2PresentTechnology
                creativeURL={creativeURL}
                setCreativeURL={setCreativeURL}
                color='white'
            />
            <PageMarketingV2Monetize />
            <PageMarketingV2PresentTablets
                creativeURL={creativeURL}
            />
            <PageMarketingV2PresentVertical
                creativeURL={creativeURL}
            />
            <PageMarketingV2PresentFrame
                creativeURL={creativeURL}
            />
            <div
                style={{
                    margin: '3em',
                    marginTop: '6em',
                }}
            >
                Adwiss @ 2024 / All rights reserved.
            </div>
        </div >
    );
}

export default PageMarketingV2;